import { Skeleton } from "@kaltura/mediaspace-shared-styled";
import styled from "@emotion/styled";

const StyledSkeletonContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
}));

const StyledSkeletonRow = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),
}));

const StyledSkeleton = styled(Skeleton)(({ theme }) => ({
    height: theme.spacing(2),
    borderRadius: theme.kaltura.shape.roundness1,
}));

export function UpdateMediaFoldersSkeleton() {
    return (
        <StyledSkeletonContainer>
            <StyledSkeleton variant={"rectangular"} width={205} />
            <StyledSkeletonRow>
                <StyledSkeleton variant={"rectangular"} width={16} />
                <StyledSkeleton variant={"rectangular"} width={205} />
            </StyledSkeletonRow>
            <StyledSkeletonRow>
                <StyledSkeleton variant={"rectangular"} width={16} />
                <StyledSkeleton variant={"rectangular"} width={205} />
            </StyledSkeletonRow>
            <StyledSkeletonRow>
                <StyledSkeleton variant={"rectangular"} width={16} />
                <StyledSkeleton variant={"rectangular"} width={205} />
            </StyledSkeletonRow>
        </StyledSkeletonContainer>
    );
}

export default UpdateMediaFoldersSkeleton;
